import {ElementCollection} from "./element-collection.js";
import {elementFactory} from "./element-factory.js";

/**
 * Builds and organizes form elements based on the given parent form, parent element, and parent collection.
 * Recursively processes nested form components within the structure.
 *
 * @param {Object} parentForm - The parent form object containing configuration or fields properties for element creation.
 * @param {Object} parentElement - The parent element within the form structure.
 * @param {Object} parentCollection - The collection to which the constructed elements will be added.
 * @return {Object} An instance of ElementCollection containing all created form elements.
 */
export function elementBuilder(parentForm, parentElement, parentCollection) {
    const formElements = new ElementCollection(parentForm, parentCollection);

    const elements = [...(parentForm.configuration?.fields ?? parentForm.fields ?? []), ...(parentForm.configuration?.sections ?? parentForm.sections ?? [])];
    for (const elementDefinition of elements) {
        const activator = elementFactory(elementDefinition);
        const formComponent = formElements.addElement(activator, elementDefinition, parentForm);

        if (Array.isArray(formComponent.fields)) {
            elementBuilder(formComponent, formComponent, formElements);
        }
    }

    return formElements;
}